import { Loader2 } from 'lucide-react';

interface FormButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  type?: 'button' | 'submit';
}

export const FormButton = ({
  children,
  onClick,
  loading = false,
  disabled = false,
  variant = 'primary',
  type = 'button',
}: FormButtonProps) => {
  const isPrimary = variant === 'primary';
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={`w-full py-3.5 px-6 rounded-[12px] font-semibold transition-all flex items-center justify-center gap-2 ${
        isPrimary
          ? `${
              isDisabled
                ? 'bg-[#FED7C9] text-white cursor-not-allowed'
                : 'bg-[#FF6A2A] text-white hover:bg-[#C2410C] active:scale-[0.98]'
            }`
          : `${
              isDisabled
                ? 'bg-[#F7F8FA] text-[#6B7280] border-2 border-[#E5E7EB] cursor-not-allowed'
                : 'bg-white text-[#111827] border-2 border-[#E5E7EB] hover:border-[#FF6A2A] hover:text-[#FF6A2A]'
            }`
      }`}
    >
      {loading && <Loader2 className="w-5 h-5 animate-spin" />}
      {children}
    </button>
  );
};
